import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export const useEmbededMode = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get('mode') === 'embeded';
};
